export const toLocalSQLDatetime = (val) => {
  if (!val) return null;
  const d = (val instanceof Date) ? val : new Date(val);
  if (isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const min = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
};

export const formatTime = (value) => {
  if (!value) return '';
  const d = (value instanceof Date) ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Estrae { hh, mm } da qualsiasi formato orario (HH:MM, HH:MM:SS, datetime completo).
// Restituisce null se il formato non è riconoscibile o i valori sono fuori range.
export const parseTime = (t) => {
  if (!t) return null;
  const match = String(t).match(/(\d{1,2}):(\d{2})/);
  if (!match) return null;
  const hh = parseInt(match[1], 10);
  const mm = parseInt(match[2], 10);
  if (isNaN(hh) || isNaN(mm) || hh > 23 || mm > 59) return null;
  return { hh, mm };
};

// Normalizza input libero "9" → "09:00", "9:5" → "09:05"
export const normalizeTime = (val) => {
  if (!val) return '';
  val = String(val).trim();
  if (/^\d{1,2}$/.test(val)) {
    const h = parseInt(val, 10);
    if (h >= 0 && h <= 23) return `${String(h).padStart(2, '0')}:00`;
  }
  if (/^\d{1,2}:\d{1,2}$/.test(val)) {
    const [h, m] = val.split(':').map(Number);
    if (h >= 0 && h <= 23 && m >= 0 && m <= 59)
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }
  return val;
};

const timeUtils = { toLocalSQLDatetime, formatTime, parseTime, normalizeTime };
export default timeUtils;
